'use client'

import React from "react";
import { BookInterface } from "../../books/types/book";
import "../BookInteractionPill/book-interaction-pill.css";
import { track } from '@vercel/analytics';

interface DetailsButtonProps {
  book: BookInterface | null;
  isDetailsOpen: boolean;
  onToggleDetails: () => void;
}

export default function DetailsButton({ 
  book, 
  isDetailsOpen, 
  onToggleDetails
}: DetailsButtonProps) {
  if (!book) return null;

  const handleClick = () => {
    track(isDetailsOpen ? "Book Details Closed" : "Book Details Opened");
    onToggleDetails();
  };

  return (
    <div className="share-button relative details-button">
      <button 
        onClick={handleClick} 
        className="action-button"
        aria-label={isDetailsOpen ? "Close book details" : "Open book details"}
      >
        {isDetailsOpen ? "Close" : "Details"}
      </button>
    </div>
  );
}